var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-signin-button',{attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onSuccess,"error":_vm.onFailure}},[_vm._v("\n  Sign in with Google\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }